@if (visible$()) {
  <div class="sol-tooltips-container">
    @for (overlay of overlays$(); track overlay.id) {
      <div
        class="sol-tooltip-overlay"
        [attr.data-tooltip-id]="overlay.id"
        [style.left.px]="overlay.left"
        [style.top.px]="overlay.top"
        [style.transform]="overlay.transform"
      >
        <div
          class="sol-tooltip"
          [class.sol-tooltip--custom]="overlay.custom"
          [class.sol-tooltip--wide]="overlay.wide"
          [id]="overlay.id"
          role="tooltip"
        >
          @if (overlay.template) {
            <ng-container *ngTemplateOutlet="overlay.template" />
          } @else {
            {{ overlay.text | translate }}
          }
        </div>
      </div>
    }
  </div>
}
